<template>
  <b-row class="mt-5">
    <b-col>
      <lunch-ticket-search class="mb-2" />
      <lunch-ticket-table />
    </b-col>
  </b-row>
</template>

<script>
import LunchTicketTable from '@/components/lunchTicket/LunchTicketTable.vue';
import LunchTicketSearch from '@/components/lunchTicket/LunchTicketSearch.vue';

export default {
  name: 'LunchTickets',
  components: {
    LunchTicketTable, LunchTicketSearch
  }
}
</script>
